import { FC } from 'react'
import FlexboxGrid from 'rsuite/FlexboxGrid'
import Tag from 'rsuite/Tag'
import useTranslation from 'next-translate/useTranslation'
import TagIcon from '@rsuite/icons/Tag'

import { useCart } from './CartProvider'
import { selectCoupons } from './selectors'
import { getCartCurrency } from '../../lib/cart'
import { formatPriceNumber } from '../../utils/math'
import { isCouponProductInclude } from '../../utils/types/guards/Order'
import { SingleOrderResponse } from '../../utils/types/Order'

import styles from '../../styles/OrderSummary.module.less'
import tagStyles from '../../styles/Tag.module.less'

interface CouponDiscountRowProps {
  orderData?: SingleOrderResponse
}

const CouponDiscountRow: FC<CouponDiscountRowProps> = ({ orderData }) => {
  const { cartState: { cart } } = useCart()
  const { t } = useTranslation('cart')

  const data = orderData ?? cart

  const [activeCoupon] = data ? selectCoupons(data) : []
  const currency = getCartCurrency(data)

  const discount = data?.included.find(isCouponProductInclude)

  const couponAmount = discount?.attributes['order.product.price']

  if (!activeCoupon || !couponAmount) {
    return null
  }

  return (
    <FlexboxGrid
      justify="space-between"
      data-testid="order-summary-attr"
      className={`${styles['summary-row']} margin-top-spacer`}
    >
      <FlexboxGrid.Item className={tagStyles['coupon-tag']}>
        {t('Coupon')}
        <Tag className={`${tagStyles.tag} ${tagStyles['discount-tag']} margin-left-spacer`}>
          <TagIcon className={`${styles['tag-icon']} margin-right-spacer-half`} />
          {activeCoupon.id}
        </Tag>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item className={tagStyles['coupon-value']}>
        {`${formatPriceNumber(couponAmount)} ${currency}`}
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}

export default CouponDiscountRow
